import type { SVGProps } from 'react';

/**
 * A root with two laterals, drawn in its thickness: one outline that tapers
 * down to each tip, open at the top where the root carries on. On lucide's
 * 24×24 grid so it sits next to lucide icons — lucide has no roots of its own.
 */
export function RootsIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            {...props}
        >
            <path
                d={[
                    // right flank, down to the right lateral
                    'M14.5 1.5C14.5 4 14.3 6 14.2 7.5',
                    // right lateral: upper edge out to its tip, lower edge back
                    // into a rounded crotch
                    'C15.5 8 17.5 9 19 10.5C20 11.5 20.6 12.5 21 13.5',
                    'C19.5 12.6 17.5 11.3 15.6 10.9C14.8 10.8 14.1 11.2 14 12',
                    // down to the main tip, and back up the left flank
                    'C13.8 15 13 18.5 11.5 22.5',
                    'C11.3 20.5 10.7 18.5 10.3 16.8',
                    // left lateral: lower edge out to its tip, upper edge back
                    'C10 16 9.2 15.7 8.4 16C6.8 16.6 5.2 17.8 3.8 19.5',
                    'C5 16.8 6.8 14.6 8.6 13.8C9.4 13.4 9.9 12.6 9.9 11.5',
                    // left flank up to the top
                    'C9.8 8 9.5 4.5 9.5 1.5',
                ].join(' ')}
            />
        </svg>
    );
}
